<script setup lang="ts">

import {label} from "../mixins/translations";
import axios from "axios";
import {useCartStore} from "../stores/cart";

interface Props{
    projectId: Number
}
const props = defineProps<Props>();
const cartStore = useCartStore();
const addToCart = () => {
    axios.post('/api/site/projects/add-to-cart/', {
        id: props.projectId,
        cart: cartStore.uuid
    }).then(function(){
        cartStore.loadCart();
        cartStore.events.emit('afterAdding');
    });
}
</script>

<template>
    <button class="cursor-pointer bg-[#73CA77] text-white font-normal py-4 px-6" @click.prevent="addToCart">
        {{ label('site.project.detail.add_to_cart') }}
    </button>
</template>
